import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { Dialog } from 'primeng/dialog';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { KeyToIconPipe } from '../../../../../core/pipes/key-to-icon.pipe';
import { I18nService } from '../../../../../core/services/i18n.service';
import { SpsCustomIconComponent } from '../../../../../custom/components/sps-custom-icon/sps-custom-icon.component';
import { SpsPaymentMethodListItemComponent } from '../../../../../custom/components/sps-payment-method-list-item/sps-payment-method-list-item.component';
import { SpsPaymentStatusTagComponent } from '../../../../../custom/components/sps-payment-status-tag/sps-payment-status-tag.component';
import { SpsMenuItem } from '../../../../../layout/interfaces/sps-menu-item';
import { LayoutService } from '../../../../../layout/services/layout.service';
import { SidebarMenuService } from '../../../../../layout/services/sidebar-menu.service';
import { CustomerPaymentMethodData } from '../../../../interfaces/payment/customer-payment-method-data';
import { PaymentData } from '../../../../interfaces/payment/payment-data';
import { PaymentDataService } from '../../../../services/payment-data.service';
import { DbNoDataInfoComponent } from '../db-no-data-info/db-no-data-info.component';

@Component({
  selector: 'db-payment-methods',
  imports: [
    Card,
    DbNoDataInfoComponent,
    SpsPaymentMethodListItemComponent,
    Dialog,
    KeyToIconPipe,
    PrimeTemplate,
    SpsCustomIconComponent,
    SpsPaymentStatusTagComponent,
    TableModule,
    NgClass,
    Button
  ],
  templateUrl: './db-payment-methods.component.html'
})
export class DbPaymentMethodsComponent implements OnInit {

  protected showPaymentTypes: boolean = false;
  protected paymentMethodPaymentTypes: PaymentData[] = [];
  selectedPaymentType: PaymentData = null;
  hasActivePaymentMethods: boolean = false;

  constructor(private router: Router,
              public i18n: I18nService,
              public layoutService: LayoutService,
              private sidebarMenuService: SidebarMenuService,
              public paymentDataService: PaymentDataService,
              private messageService: MessageService,) {
  }

  ngOnInit(): void {
    /**
     * check if there are active payment methods with payment types
     * else show the "no payment types" info
     */
    try {
      this.paymentDataService?.paymentMethods.map(pm => {
        if (pm.hasPaymentTypes) {
          this.hasActivePaymentMethods = true;
        }
      });
    } catch (e) {
    }
  }

  /**
   *
   * @param payment
   */
  onPaymentMethodClick(payment: CustomerPaymentMethodData) {
    if (!payment.hasPaymentTypes) {
      this.messageService.add({
        life: 3500,
        severity: 'infos',
        summary: 'Informatiuon',
        detail: this.i18n.i18nLng()['NOPAYMENTTYPESDATA']
      });
    } else {
      this.paymentMethodPaymentTypes = this.paymentDataService.paymentTypes.filter(pt => pt.paymentMethod === payment.name);
      this.showPaymentTypes = true;
    }
  }

  /**
   * payment type was selected -> route to specific payment type details page
   * @param event
   * @protected
   */
  protected onPaymentTypeClick(event: TableRowSelectEvent<PaymentData>) {
    try {
      let parentMenu: SpsMenuItem = this.sidebarMenuService.findMenuItemById(this.sidebarMenuService.menuItems, 'm-payment-methods');
      if (parentMenu && !parentMenu.expanded) {
        this.layoutService.sidebarMenu.activateMenuItem(parentMenu);
      }
      this.layoutService.sidebarMenu.activateMenuItem(this.sidebarMenuService.findMenuItemById(this.sidebarMenuService.menuItems, 'm-pm-' + (event.data as PaymentData).id));
      this.showPaymentTypes = false;
      this.router.navigate(['/paymentmethod/' + (event.data as PaymentData).id])
    } catch (e) {
    }
  }
}
